module.exports = __webpack_public_path__ + "static/img/banner.fe7c91ce.jpg";